import Vue from 'vue'
import Router from 'vue-router'

const Board = () => import(/* webpackChunkName: "Board" */'@/components/board/Board');
const Recap = () => import(/* webpackChunkName: "Recap" */'@/components/recap/Recap');

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Board',
      meta: {
        title: "Faites votre lauréats du ballon d'or 2019"
      },
      component: Board
    },
    {
      path: '/mon-vote/',
      name: 'Recap',
      meta: {
        title: "Résumer de votre sélection"
      },
      component: Recap
    }
  ],
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
})
